import { Link } from 'react-router-dom';
import { getRankedComics } from '@/mocks/comics';

const picks = ['dark-knight', 'moon-swordsman', 'reversal-judge'];

export default function EditorPicks() {
  const comics = getRankedComics('rating')
    .filter((c) => picks.includes(c.id))
    .slice(0, 3);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="flex items-end justify-between">
        <div>
          <span className="flex items-center gap-2 text-sm font-semibold text-accent-600">
            <i className="ri-quill-pen-fill text-base" />
            编辑推荐
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">编辑严选高分韩漫</h2>
          <p className="mt-2 text-sm text-foreground-500">由资深编辑反复筛选，口碑与品质双重背书</p>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
        {comics.map((comic, i) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="group relative overflow-hidden rounded-lg border border-background-200 bg-foreground-900"
          >
            <div className="relative h-56 w-full overflow-hidden md:h-64">
              <img
                src={comic.cover}
                alt={`${comic.title} 高分韩国漫画编辑推荐`}
                title={`${comic.title} 高分韩国漫画`}
                className="h-full w-full object-cover object-top opacity-90 transition-all duration-500 group-hover:scale-105 group-hover:opacity-100"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/30 to-transparent" />
              <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 font-heading text-base font-black text-foreground-950">
                {i + 1}
              </span>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-2.5 py-0.5 text-xs font-medium text-background-50">{comic.genre}</span>
                  <span className="flex items-center gap-1 rounded-full bg-background-50/90 px-2.5 py-0.5 text-xs font-bold text-accent-700">
                    <i className="ri-star-fill text-xs" />
                    {comic.rating.toFixed(1)}
                  </span>
                </div>
                <h3 className="mt-3 font-heading text-xl font-bold text-background-50">{comic.title}</h3>
                <p className="mt-2 line-clamp-2 text-sm text-background-100/80">{comic.summary}</p>
              </div>
            </div>
            <div className="flex items-center justify-between bg-foreground-900 px-5 py-3 text-sm text-background-100">
              <span className="flex items-center gap-2">
                <i className="ri-quote-text text-primary-400" />
                编辑点评：品质之作
              </span>
              <span className="flex items-center gap-1 text-accent-300 transition-transform group-hover:translate-x-1">
                看详情 <i className="ri-arrow-right-line text-sm" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}